
// import Color from 'color';
import { clone } from 'lodash';

export function colorWithNewAlpha(color: any, alpha: number) {
    var newColor = clone(color);

    //@ts-ignore
    newColor.valpha = alpha;

    return newColor;
}

// Various colors used throughout the app
// added into to standard "expected colors"
// for easier consistency
export const CANVAS_SLIDER_BLUE    = '#1565c0';
export const CANVAS_SLIDER_NEUTRAL = '#e59f2d';
export const CANVAS_LINK_BLUE      = '#3082A3';
export const PRIMARY_BUTTON_BLUE   = '#1C445B';
export const PRIMARY_FINDING_COLOR = '#77aca2';
export const PRIMARY_NEUTRAL_GREY  = '#BDBDBD';
export const PRIMARY_NEUTRAL_BLUE  = "#9ad2fc";
export const PRIMARY_DARK_GREY     = '#F7F7F8';
export const BADGE_DARK_GREY       = "#212121";
export const CHARTS_GREEN          = "#BFE3C0";
export const CHARTS_RED            = "#F1ADAC";
export const PRIMARY_IW_BLUE       = "#1e445a";
export const INSIGHT_ORANGE        = "#f4b400";
export const CANVAS_LINK_PURPLE    = '#8753B8';

export const colors = {
    CANVAS_SLIDER_BLUE,
    CANVAS_LINK_BLUE, PRIMARY_BUTTON_BLUE, PRIMARY_FINDING_COLOR,
    PRIMARY_NEUTRAL_GREY, PRIMARY_DARK_GREY, CANVAS_SLIDER_NEUTRAL,
    CHARTS_GREEN, CHARTS_RED, PRIMARY_NEUTRAL_BLUE, PRIMARY_IW_BLUE,
    INSIGHT_ORANGE,
    CANVAS_LINK_PURPLE
}
